/*
 * Copyright (c) 2020 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

import { env } from './.env';

export const environment = {
  production: true,
  hmr: false,
  version: env.npm_package_version,
  serverPredix: 'https://localhost:9094',
  serverPlay: 'http://localhost:9000',
  defaultLanguage: 'en-US',
  supportedLanguages: ['en-US', 'fr-FR'],
  proxyPath: ''
};
